import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { getRequiredConfig } from '@klpkonsern/appconfig';
import { Conditional } from '@klp/conditional';
import { AppRoutes } from '@klp/core/app/config';
import { useAppParams } from '@klp/core/app/useAppParams';
import { ErrorNotification } from '@klp/errorNotification';
import { IFrame } from '@klp/iframe';
import { Main } from '@klp/layout';
import { generateRouteParams } from '@klp/routing';

interface IdxboFrameParams {
    language: string;
    autologin: boolean;
    hiddenNavbar: boolean;
    kundeNummer?: string;
}

export const ProjectDxboFrame: React.FC = () => {
    const params = useAppParams();
    const { i18n } = useTranslation();
    const { isAdmin, selectedClient } = params;
    const dxboPath = (params as any).dxboPath as string | undefined;

    const isOpenInNewTab = () => {
        return true;
    };

    const openDxbo = useCallback(
        (destination: string) => () => {
            window.open(destination, 'Dxbo');
        },
        [],
    );

    const frameParams: IdxboFrameParams = {
        language: i18n.language,
        autologin: true,
        hiddenNavbar: false,
    };

    if (selectedClient?.kundeNummer) {
        frameParams.kundeNummer = selectedClient.kundeNummer;
    }

    const url = (
        isAdmin
            ? getRequiredConfig('WEBAPP_PROJECTDXBO_URL_ADMIN')
            : getRequiredConfig('WEBAPP_PROJECTDXBO_URL_USER')
    )
        .concat(dxboPath || '')
        .concat(generateRouteParams(frameParams));

    return (
        <Main fullScreen={!isOpenInNewTab()} withoutHeader={!isOpenInNewTab()}>
            <Conditional
                condition={!isOpenInNewTab()}
                errorComponent={
                    <ErrorNotification
                        type="Default"
                        title="dxboFrame.externalFrame.title"
                        description="dxboFrame.externalFrame.description"
                        mainTitle="dxboFrame.externalFrame.actionButton"
                        backTarget={AppRoutes.mainPage()}
                        mainClickHandler={openDxbo(url)}
                        backTitle="general.goBackToFrontpage"
                        mainTargetButtonType="external"
                    />
                }
            >
                <IFrame src={url} fullScreen={true} noSandbox={true} />
            </Conditional>
        </Main>
    );
};
